import { PremiseDetails } from "src/components/Changes/types";
import { Contact, RequestingCompany, UploadedFile } from "../types";
import { ChangeElectricityJobType, RequesterType } from "./helpers";
import { MirnStatusEnum, NmiStatusEnum } from "./StatusAlert";

export interface ChangeRequestFormValues {
  // Lodged request metadata - not present in draft
  requester?: string;
  submittedDateTime?: Date;

  requestingCompany: RequestingCompany | null;
  relationship: RequesterType;
  energyType: string;
  nmi: string;
  mirn: string;
  nmiStatus?: NmiStatusEnum;
  mirnStatus?: MirnStatusEnum;
  premise: PremiseDetails | null;
  noCompany: boolean | null;

  changeTypes: ChangeElectricityJobType[];

  licensedElectrician: string | null;
  licensedElectricians?: Contact[];

  electricianFields: ElectricianFields;

  meteringRequirements: {
    meterProvider: string;
    offPeakRequirements: string[];
    otherOffPeakRequirements: string | null;
  };
  supplyDetails: {
    maxLoad: string;
    numberOfPhases: string;
    supplyType: string;
    offPeakRequirements: string[];
    transformer: boolean;
  };
  meterAccess: {
    meterLocation: string;
    meterBehindGate: "yes" | "no" | null;
    accessInstructions: string;
    accessDetails: string | null; //this is the combination of meterLocation and accessInstructions post submission
    meterInsideProperty: "yes" | "no" | null;
    dogOnSite: "yes" | "no" | null;
    coordinationOfElectricalWorks: "yes" | "no" | null;
  };

  solarInstallationDetails: {
    installationDate: Date | null;
  };
  supportingDocuments: {
    rexId: string | null;
    coesReferenceNumber: string | null;
  };
  coesFiles: UploadedFile[];
  ewrFiles: UploadedFile[];
  //post submission fields
  supplyServiceOrderNumber: string | null;
  networkFormNumber: string | null;
  requesterName: string | null;
  requesterEmail: string | null;
  channel: string | null;
}

export interface ElectricianFields {
  firstName: string | null;
  lastName: string | null;
  companyName: string | null;
  phoneNumber: string | null;
  emailAddress: string | null;
  licenceNumber: string | null;
}

export const initialValues: ChangeRequestFormValues = {
  requestingCompany: null,
  relationship: RequesterType.PROPERTY_OWNER,
  energyType: "electricity",
  nmi: "",
  mirn: "",
  premise: null,
  changeTypes: [],
  licensedElectrician: null,
  electricianFields: {
    firstName: null,
    lastName: null,
    companyName: null,
    phoneNumber: null,
    emailAddress: null,
    licenceNumber: null,
  },
  noCompany: false,
  meteringRequirements: {
    meterProvider: "origin",
    offPeakRequirements: [],
    otherOffPeakRequirements: null,
  },

  supplyDetails: {
    maxLoad: "",
    numberOfPhases: "1",
    supplyType: "overhead",
    offPeakRequirements: [],
    transformer: false,
  },

  meterAccess: {
    meterLocation: "",
    accessInstructions: "",
    accessDetails: null,
    dogOnSite: "no",
    coordinationOfElectricalWorks: "no",
    meterBehindGate: "no",
    meterInsideProperty: "no",
  },
  solarInstallationDetails: {
    installationDate: null,
  },
  supportingDocuments: {
    rexId: null,
    coesReferenceNumber: null,
  },
  coesFiles: [],
  ewrFiles: [],
  supplyServiceOrderNumber: null,
  networkFormNumber: null,
  requesterName: null,
  requesterEmail: null,
  channel: null,
};
